export default __webpack_public_path__ + "static/media/logo.8b36ea16.gif";